import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 10,
      refetchOnWindowFocus: true,
      retry: 3,
      onError: (erro) => {
        console.error('Erro na query:', erro);
      },
    },
    mutations: {
      onError: (erro) => {
        console.error('Erro na mutação:', erro);
      },
    },
  },
});

export { queryClient };